var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9997 0.426025C7.83301 0.426025 0.333008 7.90936 0.333008 17.1261C0.333008 25.4594 6.43301 32.3761 14.3997 33.6261V21.9594H10.1663V17.1261H14.3997V13.4427C14.3997 9.25936 16.883 6.95936 20.6997 6.95936C22.5163 6.95936 24.4163 7.27603 24.4163 7.27603V11.3927H22.3163C20.2497 11.3927 19.5997 12.676 19.5997 13.9927V17.1261H24.233L23.483 21.9594H19.5997V33.6261C23.527 33.0057 27.1033 31.0019 29.6828 27.9761C32.2623 24.9504 33.6753 21.1021 33.6663 17.1261C33.6663 7.90936 26.1663 0.426025 16.9997 0.426025Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.7bec6b3d3978e3983d274d974c75571c.svg";
export { ForwardRef as ReactComponent };